module.exports = __webpack_public_path__ + "img/cdmx.c923df83.jpg";